import { FC, useState,useEffect } from 'react'

import './style.scss'
import CONFIG from '../../../../config'
import { IMenuFavorite, FormResponseStatus, EDocumentType } from '../../../models'
import menuData from '../../../utils/menu'
import { useAuth, useAppointments, usePreferential } from '../../../hooks'
import { Layout } from '../../../containers'
import { Button, Card, Title, Text, Icon, Link, Slider, Modal, useModal, Loading, Line, Alert } from '../../../components/UI'
import { MedicalAppointmentsSummary, MenuFavoritesSummary, MenuFavoritesForm } from '../../../components/Dashboard'
import { menuService } from '../../../services'

const TitleCard:FC<{ className?: string }> = ({ children, className = '' }) => {
  return <Title component="h2" size="16" color="primary" weight="bold" className={className}>{children}</Title>
}

const BoxAppointmentUpcoming:FC<{ appointment: any, onShow(): void }> = ({ appointment, onShow }) => {
  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <TitleCard>Próximas citas médicas</TitleCard>

        {appointment && appointment.appointments && appointment.appointments.length > 0 &&
          <Button color="secondary" size="sm" onClick={onShow}>RESERVA DE HORAS</Button>
        }

        <Line fullWidth className="lg:d-none" />
      </div>

      {appointment ?
          <>
            {appointment.appointments && appointment.appointments.length ?
                <>
                  <MedicalAppointmentsSummary
                    appointments={appointment.appointments}
                    className="mt-20"
                  />

                  {appointment.see_more &&
                    <div className="text-center mt-30">
                      <Button component="link" size="sm" to={CONFIG.ROUTES.DASHBOARD.MEDICALAPPOINTMENTS.HOME}>VER MÁS</Button>
                    </div>
                  }
                </>
              :
                <div className="text-center mt-50">
                  <Text>No tienes horas reservadas</Text>
                  <Button color="secondary" size="md" className="mt-20" onClick={()=>{ window.location.href = '/dashboard/agenda';}}>RESERVA DE HORAS</Button>
                </div>
            }
          </>
        :
          <Loading size="md" align="center" className="py-50" />
      }
    </>
  )
}

const SummaryPage:FC = ()  => {
  const userCurrent = useAuth()
  const modal = useModal()
  const [favorites, setFavorites] = useState<IMenuFavorite[] | null>(null)
  const appointmentData = useAppointments('SUMMARYALL')
  const appointmentUpcoming = useAppointments('SUMMARYUPCOMINGS')
  const { preferentials } = usePreferential()

  useEffect(() => {
    getFavorites()
  }, [])

  const getFavorites = async () => {
    const resp = await menuService.getFavoritesByUserCurrent()
    setFavorites(resp.data)
  }

  const onFavoriteSubmit = (status: FormResponseStatus) => {
    if(status === 'SUCCESS') {
      setFavorites(null)
      getFavorites()
      modal.close()
    }
  }

  const onAppointmentShow = () => {
    (window as any).show_chat()
  }
  const { document_type_id } = userCurrent.getInfo()

  return (
    <Layout menu titleMain={1}>
      {document_type_id === EDocumentType.passport &&
        <Alert type="INFO" className="mb-15" style={{ marginTop: -30 }}>
          <Text size="13" lineHeight="2">{CONFIG.MESSAGE.REGISTER.PASSPORT_ALERT}</Text>
        </Alert>
      }

      <Title border>{userCurrent.getWelcome()}, {userCurrent.getUserFullName()}</Title>

      <div className="row mt-50 lg:mt-40">
        <div className="col-12 lg:col-5 lg:pl-10 lg:order-2">
          <Card showOnly="lg" className="summary-box-2 lg:p-20">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <TitleCard>Favoritos</TitleCard>

              <Link size={12} color="black" onClick={() => modal.open()}><Icon name="edit" size={14} color="gray-700" className="align-middle mr-5" />Editar Favoritos</Link>

              <Line fullWidth className="lg:d-none" />
            </div>

            <MenuFavoritesSummary
              menu={menuData}
              favorites={favorites}
              className="mt-25"
            />
          </Card>

          <Card showOnly="lg" className="summary-box-1 lg:d-none mt-50">
            <BoxAppointmentUpcoming
              appointment={appointmentUpcoming.data}
              onShow={onAppointmentShow}
            />
          </Card>

          <Card showOnly="lg" className="summary-box-3 lg:p-20 mt-50 lg:mt-20">
            <TitleCard>Conecta con INDISA</TitleCard>
            <Line fullWidth className="lg:d-none" />

            <Slider
              slides={preferentials && preferentials.length ? preferentials : []}
              className="mt-20"
            />
          </Card>
        </div>

        <div className="col-12 lg:col-7 d-none lg:d-flex lg:flex-column pr-10 lg:order-1">
          <Card showOnly="lg" className="summary-box-1 p-20">
            <BoxAppointmentUpcoming
              appointment={appointmentUpcoming.data}
              onShow={onAppointmentShow}
            />
          </Card>

          <Card showOnly="lg" className="summary-box-1 p-20 mt-20">
            <TitleCard>Historial de citas médicas</TitleCard>
            <Line fullWidth className="lg:d-none" />

            {appointmentData.data ?
                <>
                  {appointmentData.data.appointments && appointmentData.data.appointments.length ?
                      <>
                        <MedicalAppointmentsSummary
                          appointments={appointmentData.data.appointments ? appointmentData.data.appointments : []}
                          className="mt-20"
                        />

                        {appointmentData.data.see_more &&
                          <div className="text-center mt-30">
                            <Button component="link" size="sm" to={CONFIG.ROUTES.DASHBOARD.MEDICALAPPOINTMENTS.PASTHOURS}>VER MÁS</Button>
                          </div>
                        }
                      </>
                    :
                      <Text align="center" className="mt-70">Aún no tienes citas médicas en este historial</Text>
                  }
                </>
              :
                <Loading size="md" align="center" className="py-50" />
            }
          </Card>
        </div>
      </div>

      <Modal show={modal.show} maxWidth="860px" onClose={() => modal.close()} >
        <MenuFavoritesForm
          menu={menuData}
          defaultChecked={favorites}
          onSubmitChange={(status) => onFavoriteSubmit(status)}
          onCancel={() => modal.close()}
        />
      </Modal>
    </Layout>
  )
}

export { SummaryPage }